import {
  BMComponentsType,
  BMPrimitives,
  BMText,
  useBMTheme,
} from "@traveloka/district-bloom";
import IcSystemStatusWarning16 from "@traveloka/icon-kit-web/react/IcSystemStatusWarning16";
import { useMemo } from "react";
import { Pressable, StyleSheet } from "react-native";

import BMView from "../../../../../../components/View/BMView";
import { useMobileContentResource } from "../../../../../../core/resource/MobileResourceProvider";

type BaggageCatalogErrorProps = {
  onRetry?: () => void;
};

export default function BaggageCatalogError({
  onRetry,
}: BaggageCatalogErrorProps) {
  const { CorporateFlightPrebookForm: cr } = useMobileContentResource();

  const { BMComponents } = useBMTheme();
  const styles = useMemo(() => createStyles(BMComponents), [BMComponents]);

  return (
    <BMView spacing="sm" style={styles.containter}>
      <BMView row spacing="sm">
        <BMView>
          <IcSystemStatusWarning16
            width={24}
            height={24}
            color={BMComponents.BMStyleIconInkHighlightYellow}
          />
        </BMView>
        <BMView flex>
          <BMText variant="uiLarge">{cr.baggageCatalogErrorStateTitle}</BMText>
          <BMText variant="paragraphSmall" ink="BMStyleTextInkSecondary">
            {cr.baggageCatalogErrorStateDescription}
          </BMText>
        </BMView>
      </BMView>
      <BMView align="end">
        <Pressable onPress={onRetry}>
          <BMText ink="BMStyleTextInkAction">
            {cr.baggageCatalogErrorStateCta}
          </BMText>
        </Pressable>
      </BMView>
    </BMView>
  );
}

const createStyles = (BMComponents: BMComponentsType) =>
  StyleSheet.create({
    containter: {
      padding: BMPrimitives.BMSize.md,
      borderWidth: BMPrimitives.BMBorder.width.thick,
      borderColor: BMComponents.BMStyleLineBordercolorWarning,
      backgroundColor: BMComponents.BMStyleSurfaceBgcolorHighlight,
      borderRadius: BMPrimitives.BMBorder.radius.default,
    },
  });
